<template>
  <!-- 房源管理列表 -->
  <div class="content">
    <!-- this.$router.push({
        path: '/houses/detail/index',
        query: {
          id: val,
          formTitle: '出租详情'
        }
      }) -->
    <!-- <div class="loading" v-if="loading">加载中...</div>
    <router-link
      v-for="item in records"
      :key="item.id"
      to="{path: '/houses/detail/index', query: {id:'2',formTitle: '出租详情'}}"
      v-else> -->
    <a-row class="menudetail" v-for="item in records" :key="item.id">
      <a-col :span="8" style="display: flex; height: 100%">
        <div class="img">
          <!-- <div v-if="item.houseInfoImgVo.interiorList">
            <img class="img_titlePic" :src="OSS_BASE_URL + item.houseInfoImgVo.interiorList[0].fileName" alt="" />
          </div> -->
          <div @click="housePush(item.id, item)" v-if="item.houseInfoImgVo.thisShopList&&item.houseInfoImgVo.thisShopList.length">
            <img class="img_titlePic" :src="OSS_BASE_URL +item.houseInfoImgVo.thisShopList[0].fileName" alt="" />
          </div>

          <div @click="housePush(item.id, item)" v-else class="img_titlePic">
            <!-- 暂无图片 -->
            <!-- <no-data></no-data> -->
            <img style="width: 80px" src="../../assets/images/nodataImg.svg" alt="" />
          </div>
          <p
            style="text-align: center; color: black; font-size: 14px"
            class="tag-read"
            :class="{ copySelClass: curText === item.houseCode }"
            :data-clipboard-text="item.houseCode"
            @click="copy(item.houseCode)"
          >
            {{ item.houseCode }}
          </p>
          <div class="tag_key">
            <!-- <span v-if="item.identityAlone === 'Y'" class="font_red">独</span>
            <span v-if="item.identityExcellent === 'Y'" class="font_red">优</span>
            <span v-if="item.identityFive === 'Y'" class="font_red">五</span>
            <span v-if="item.identityKey === 'Y'" class="iconfont icon-yuechi font_gold"></span> -->
            <img
              v-if="item.identityAlone === 'Y'"
              class="icon_tag_key"
              src="@/assets/icons/icon_du.png"
              title=""
              alt=""
            />
            <img
              v-if="item.identityFive === 'Y'"
              class="icon_tag_key"
              src="@/assets/icons/icon_5.png"
              title=""
              alt=""
            />
            <img
              v-if="item.identityExcellent === 'Y'"
              class="icon_tag_key"
              src="@/assets/icons/icon_good.png"
              title=""
              alt=""
            />
            <img
              v-if="item.identityKey === 'Y'"
              class="icon_tag_key"
              src="@/assets/icons/icon_key.png"
              title=""
              alt=""
            />
            <img
              v-if="item.houseStatus"
              class="icon_tag_key"
              :src="statusImgs[item.houseStatus]"
              title=""
              alt=""
            />
            <!-- <a-tag class="icon-tag-item" color="green">{{ filterHouseStatus(item.houseStatus) }}</a-tag> -->
          </div>
        </div>
        <div class="title" @click="housePush(item.id, item)">
          <div class="name" :title="item.shopName">
            {{ item.shopName }}
          </div>
          <div class="houseNeme" :title="item.districtName + item.businessDistrictName + item.streetName">
            {{ item.districtName }}{{ item.businessDistrictName }}{{ item.streetName }}
          </div>
          <div class="houseNeme">
            <!-- 商铺类型 -->
            <!-- <div v-for="d in shopType" :key="d.dictValue" >
                            <span v-if="d.dictValue==item.shopTypeId">{{d.dictLabel}}</span>
                        </div> -->
          </div>
          <div class="btn">
            <!-- 餐饮类型 -->
            <!--  {{item.alloweCateringTypeId}} -->
            <!-- <span class="green minw60" v-if="item.isCatering === 'Y' && item.alloweCateringTypeId">
              <div v-for="d in repastTypeOpts" :key="d.dictValue">
                <a-tag v-if="d.dictValue == item.alloweCateringTypeId">{{ d.dictLabel }}</a-tag>
              </div>
            </span> -->
            <a-tag v-if="item.isCatering === 'Y' && item.alloweCateringTypeId" color="green">
              {{ item.alloweCateringTypeId | filterDict(repastTypeOpts) }}
            </a-tag>
            <a-tag v-else color="green">拒餐饮</a-tag>

            <!-- 自定义标签 -->
            <!-- <span class="yellow minw60" v-if="item.tagsContentArray">
              {{ item.tagsContentArray.split(',')[0] }}
            </span> -->
            <a-tag color="yellow" v-if="item.tagsContentArray">{{ item.tagsContentArray.split(',')[0] }}</a-tag>
            <!-- 商铺配套 -->
            <!-- <span class="red minw60" v-if="item.shopAncillary">
              {{ item.shopAncillary.split(',')[0] }}
            </span> -->
            <a-tag color="red" v-if="item.shopAncillary"> {{ item.shopAncillary.split(',')[0] }}</a-tag>
          </div>
        </div>
      </a-col>
      <a-col :span="4" style="padding-top: 25px" @click="housePush(item.id, item)">
        <div style="color: black">
          <div style="font-weight: bold">建:{{ item.grossFloorArea }}m²,实:{{ item.saleableArea }}m²</div>
          <div class="house">面宽:{{ item.houseWide }}m,层高:{{ item.houseHigh }}m</div>
          <div class="house">{{ item.houseFloor }}层，共{{ item.floorTotal }}层</div>
        </div>
      </a-col>
      <a-col :span="4" style="padding-top: 25px" @click.native="housePush(item.id, item)">
        <div style="color: black">
          <div style="color: #ff725b; font-weight: bold">{{ item.rentFee || '--' }}元/月</div>
          <div class="house">{{ item.rentFeeCentiare || '--' }}元/m²/月</div>
          <div class="house">{{ item.rentFeeCentiare ? (item.rentFeeCentiare / 30).toFixed(2) : '--' }}元/m²/天</div>
        </div>
      </a-col>
      <a-col :span="3" style="padding-top: 25px" @click.native="housePush(item.id, item)">
        <div style="color: black">
          <div style="font-weight: bold">
            {{ item.followUpCreateTime ? $moment(item.followUpCreateTime).format('YY-MM-DD HH:mm') : '暂无' }}跟进
          </div>
          <div v-if="item.takeLookCount || item.takeLookCount === 0">
            <p class="house">{{ item.takeLookCount }}次被带看</p>
            <!-- <p>{{ item.takeLookCount }}次一带多看</p> -->
          </div>
          <div v-else>
            <p style="margin-top: 8px; margin-bottom: 6px">
              本周带看{{ item.takeLookCountWeek ? item.takeLookCountWeek : 0 }}次
            </p>
            <p>本月带看{{ item.takeLookCountMonth ? item.takeLookCountMonth : 0 }}次</p>
          </div>
        </div>
      </a-col>
      <a-col :span="2" style="padding-top: 25px" v-if="item.validTime" @click.native="housePush(item.id, item)">
        <div>
          {{ item.validTime ? $moment(item.validTime).format('YY-MM-DD HH:mm') : '--' }}
        </div>
        <div>录入时间</div>
      </a-col>
      <a-col :span="2" style="padding-top: 25px" @click.native="housePush(item.id, item)">
        <div style="color: black">
          <div style="font-weight: bold">
            <!-- {{ item.storeName || '*' }}- -->
            <span v-if="item.teamName">{{ item.teamName || '*' }}-</span>{{ item.relatedPersonnelName }}
          </div>
          <div class="house">
            {{
              item.relatedPersonnelCreateTIme
                ? $moment(item.relatedPersonnelCreateTIme).format('YY-MM-DD HH:mm')
                : '--'
            }}创建时间
          </div>
        </div>
      </a-col>
      <a-col :span="1" style="padding-top: 45px" @click.native="housePush(item.id, item)">
        <div>
          <a-button
            class="btn"
            type="primary"
            style="background-color: #389e0d; border-radius: 20px; border: none; font-size: 12px"
            v-if="item.dishType == 1"
          >
            私盘
          </a-button>
          <a-button
            class="btn"
            type="primary"
            style="background-color: #d48806; border-radius: 20px; border: none; font-size: 12px"
            v-if="item.dishType == 2"
          >
            单店
          </a-button>
          <a-button
            class="btn"
            type="primary"
            style="background-color: #cf1322; border-radius: 20px; border: none; font-size: 12px"
            v-if="item.dishType == 3"
          >
            公司
          </a-button>
        </div>
      </a-col>
    </a-row>
    <!-- </router-link> -->
  </div>
</template>

<script>
import houseApi from '@/api/system/houses/house.js'
import { copyTextMixin } from '@/mixin/copyTextMixin'
const OSS_BASE_URL = process.env.VUE_APP_OSS_URL
export default {
  name: 'HouseListCmp',
  // components: {},
  props: {
    // 房源菜单列表
    records: {
      type: Array,
      default: () => [],
      require: true
    },
    activeNum: {
      type: [String, Number],
      default: ''
    }
  },
  mixins: [copyTextMixin],
  data () {
    return {
      loading: false,
      names: {
        thisShopList: null
      },
      OSS_BASE_URL,
      shopType: [],
      repastTypeOpts: [],
      shopAncillaryOpts: [],
      CusListData: [],
      dishTypeOpts: [],
      ossimg: '',
      houseStatus: [], // 房源状态
      // 房源状态图
      statusImgs: {
        '1': require('@/assets/icons/icon_up.png'),
        '6': require('@/assets/icons/icon_d.png'),
        '4': require('@/assets/icons/icon_no.png'),
        '2': require('@/assets/icons/icon_myExchange.png'),
        '3': require('@/assets/icons/icon_autoExchange.png')
      }

    }
  },
  created () {
    this.loading = true
    // 商铺类型
    this.getDicts('shop_type').then((res) => {
      this.shopType = res.data
    })
    // 餐饮类型
    this.getDicts('repast_type').then((response) => {
      this.repastTypeOpts = response.data
    })
    // 商铺配套
    this.getDicts('shop_ancillary').then((response) => {
      this.shopAncillaryOpts = response.data
    })
    // 盘别
    this.getDicts('dish_type').then((response) => {
      this.dishTypeOpts = response.data
    })

    // 房源状态
    this.getDicts('house_status').then((response) => {
      this.houseStatus = response.data
    })

    this.getCusTag()
    this.loading = false
  },
  methods: {
    // 查询房源自定义标签列表
    getCusTag () {
      houseApi.GethouseCustomTag({ tagName: '' }).then((res) => {
        if (res.code === 200) {
          this.CusListData = res.data
        }
      })
    },
    // 过滤房源状态
    filterHouseStatus (val) {
      const obj = this.houseStatus.find(el => el.dictValue === val)
      if (obj) {
        return obj.dictLabel
      }
    },
    housePush (val, item) {
      console.log('详情', item)
      localStorage.setItem('scrollTop', document.body.scrollTop || document.documentElement.scrollTop)
      sessionStorage.setItem('history', JSON.stringify({ fromPage: 'list' }))
      this.$router.push({
        path: '/houses/detail/index',
        query: {
          id: val,
          formTitle: '出租详情',
          activeNum: this.activeNum,
          storeId: item.storeId,
          teamId: item.teamId,
          userStatus: item.userStatus,
          canTabs: true
        }
      })
    }
  },
  watch: {
    // 监听
    activeNum: {
      handler (val) {},
      immediate: true
    },
    houeseType1: {
      handler (newVal, oldVal) {
        console.log(125)
        console.log(newVal, oldVal)
      }
    },
    deep: true
  }
}
</script>

<style lang="less" scoped>
@titleFontSize: 20px;
@titleColor: #222;
@bodyFont: 14px;
@bodyColor: #666;
@tagFont: 12px;
@tagColor: #ddd;

.menu .ant-tabs-bar {
  width: 100% !important;
}
.minw60 {
  min-width: 60px;
  width: 65px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.font_gold {
  color: #f8cb00;
  font-size: 20px;
  margin-top: -2px;
  margin-left: 15px;
}
.content {
  .menudetail {
    &:hover {
      background: #f0f5ff;
    }
    margin-top: 20px;
    // height: 250px;
    cursor: pointer;
    border-bottom: 2px solid #f2f6fc;
    width: 100%;
    display: flex;
    justify-content: center;
    padding-bottom: 30px;
    &:hover {
      background: rgba(0, 0, 0, 0.1);
    }
    .img {
      width: 155px;
      height: 108px;
      object-fit: cover;
      .img_titlePic {
        object-fit: cover;
        width: 155px;
        text-align: center;
        height: 86px;
        margin-bottom: 10px;
        border-radius: 3px;
      }
    }
    .tag_key {
      position: absolute;
      top: 0px;
      // left: 58px;
      left: 0px;
      z-index: 2;
      // background: rgba(255,255,255,0.6);
      text-align: center;
      letter-spacing: 3px;
      padding: 0 5px;
      display: flex;
      align-items: center;
      // width: 100px;
      .icon_tag_key {
        // padding: 1px;
        // width: 20px;
        height: 20px;
        // margin-top: 5px;
        background: rgba(255, 255, 255, 0.8);
        box-shadow: 0px 0px 3px #888;
        -webkit-box-shadow: 0px 0px 3px #888;
        margin-right: 2px;
      }
      .icon-tag-item{
        display: inline-block;
      }
      .font_red {
        color: #ff0000;
        font-weight: bold;
        box-shadow: 0px 3px 5px #666;
        background: rgba(255, 255, 255, 0.8);
        margin-left: 2px;
      }
    }
    .title {
      color: #000;
      margin-left: 20px;
      width: calc(100% - 175px);
      .name {
        width: 98%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .houseNeme {
        margin-top: 5px;
        // width: 200px;
        width: 98%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      p {
        height: 18px;
      }
      .name {
        font-size: @bodyFont;
        color: @bodyColor;
        font-weight: bold;
      }
      .btn {
        display: flex;
        margin-top: 10px;
        .green {
          display: inline-block;
          margin-right: 5px;
          // background-color: #eef8e8;
          // border: 1px solid #91d668;
          background-color: #91d668;
          font-size: 7px;
          padding: 9px;
          line-height: 2px;
          border-radius: 5px;
          color: #fff;
          text-align: center;
        }
        .yellow {
          display: inline-block;
          margin-right: 5px;
          background-color: var(--ThemeColor);
          font-size: 7px;
          padding: 9px;
          line-height: 2px;
          border-radius: 5px;
          text-align: center;
          color: #fff;
        }
        .red {
          display: inline-block;
          margin-right: 5px;
          background-color: #f26161;
          font-size: 7px;
          padding: 9px;
          line-height: 1px;
          border-radius: 5px;
          color: #fff;
        }
      }
    }
  }
  .house {
    margin-top: 8px;
  }
}
.copySelClass {
  background: var(--ThemeColor);
}
</style>
